/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthenticationConfiguration } from '../../models/authentication-configuration';
import { CreateAuthenticationConfigurationRequest } from '../../models/create-authentication-configuration-request';

export interface CreateAuthenticationConfiguration$Params {
  organizationId: string;
  
    /**
     * Authentication configuration to be created.
     */
    body: CreateAuthenticationConfigurationRequest
}

export function createAuthenticationConfiguration(http: HttpClient, rootUrl: string, params: CreateAuthenticationConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthenticationConfiguration>> {
  const rb = new RequestBuilder(rootUrl, createAuthenticationConfiguration.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthenticationConfiguration>;
    })
  );
}

createAuthenticationConfiguration.PATH = '/v1/organizations/{organizationId}/configuration/authentication';
